import {Component, EventEmitter, Input, Optional, Output} from '@angular/core';
import {AcFormComponent} from '../ac-form/ac-form.component';
import {AcInputContainerComponent} from '../ac-input-container/ac-input-container.component';
import {AcInputContainerOldComponent} from '../ac-input-container-old/ac-input-container-old.component';

@Component({
    selector: 'ac-checkbox',
    templateUrl: './ac-checkbox.component.html',
    styleUrls: ['./ac-checkbox.component.less'],
})

export class AcCheckboxComponent {
    @Input() set acModel(model: boolean | 'indeterminate') {
        this.model = model;
        this.indeterminate = model === 'indeterminate';
    }

    @Input() checkboxId = '';
    @Input() labelText = '';
    @Input() labelPosition: 'before' | 'after' = 'after';
    @Input() ngDisabled: boolean;
    @Input() sideMargin = true;
    @Input() labelOnly = false;
    @Input() noRipple = false;

    @Output() acModelChange: EventEmitter<boolean> = new EventEmitter<boolean>();


    model;
    indeterminate: boolean;
    acInputContainer;

    constructor(@Optional() public acInputContainerComponent: AcInputContainerComponent,
                @Optional() public acInputContainerOldComponent: AcInputContainerOldComponent,
                @Optional() public acFormComponent: AcFormComponent) {
    }

    ngOnInit() {
        this.acInputContainer = this.acInputContainerOldComponent || this.acInputContainerComponent;
        if(this.acFormComponent && this.acFormComponent.isViewMode){
            this.ngDisabled = true;
        }
    }

    checkboxValueChanged($event) {
        this.acModelChange.emit($event);
    }
}



